// Mindscreen.ImageGallery
import '../../../../../Packages/Application/Mindscreen.ImageGallery/Resources/Public/Css/frontend.css';
import '../../../../../Packages/Application/Mindscreen.ImageGallery/Resources/Public/JavaScript/frontend';
